// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgIconStyle from "../../../components/SvgIconStyle";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  dashboard: getIcon("ic_dashboard"),
  courier: getIcon("ic_courier"),
  school: getIcon("ic_school"),
  chart: getIcon("ic_pieChart"),
  search: getIcon("ic_search"),
  tuckshop: getIcon("ic_tuckshop"),
  archival: getIcon("ic_archival"),
  master: getIcon("ic_master"),
  parent: getIcon("ic_parent"),
  report: getIcon("ic_report"),
  // ticket: getIcon("ic_bug"),
  orderStatus: getIcon("ic_order_status"),
  ticket: getIcon("ic_ticket"),
  OrderPromotion: getIcon("ic_promotion"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
      },
      {
        title: "Courier Dashboard",
        path: PATH_DASHBOARD.general.courierDashboard,
        icon: ICONS.courier,
      },
      {
        title: "school-order",
        path: PATH_DASHBOARD.general.schoolOrder,
        icon: ICONS.school,
      },
      {
        title: "Variation Bulk Update",
        path: PATH_DASHBOARD.general.orderPromotion,
        icon: ICONS.OrderPromotion,
      },
      {
        title: "Global Order Search",
        path: PATH_DASHBOARD.general.globalSearchOrder,
        icon: ICONS.search,
      },
      {
        title: "Tuckshop",
        path: PATH_DASHBOARD.general.adminOrder,
        icon: ICONS.tuckshop,
      },
      {
        title: "Archival",
        path: PATH_DASHBOARD.general.archival,
        icon: ICONS.archival,
      },
      {
        title: "Check Order Status",
        path: PATH_DASHBOARD.general.orderStatus,
        icon: ICONS.orderStatus,
      },
      // {
      //   title: "Missing Items",
      //   path: PATH_DASHBOARD.general.tickets,
      //   icon: ICONS.ticket,
      // },
      {
        title: "Raised Ticket",
        path: PATH_DASHBOARD.general.raisedTicket,
        icon: ICONS.ticket,
      },
      {
        title: "Student Sizing",
        path: PATH_DASHBOARD.general.studentSizing,
        icon: ICONS.report,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: "Master Module",
    items: [
      // USER
      {
        title: "Master",
        path: PATH_DASHBOARD.master.root,
        icon: ICONS.master,

        children: [
          { title: "Category", path: PATH_DASHBOARD.master.category },
          { title: "House", path: PATH_DASHBOARD.master.house },
          { title: "Variation", path: PATH_DASHBOARD.master.variation },
          { title: "Vendor", path: PATH_DASHBOARD.master.vendor },
          { title: "School", path: PATH_DASHBOARD.master.school },
          { title: "Grade", path: PATH_DASHBOARD.master.standard },
          { title: "Product", path: PATH_DASHBOARD.master.product },
          { title: "Package", path: PATH_DASHBOARD.master.package },
          { title: "Shipping Methods", path: PATH_DASHBOARD.master.shipping },
          {
            title: "Ticket Category",
            path: PATH_DASHBOARD.master.ticketCategory,
          },
          {
            title: "Promocode",
            path: PATH_DASHBOARD.master.promocode,
          },
          {
            title: "Publisher",
            path: PATH_DASHBOARD.master.publisher,
          },
          {
            title: "Party",
            path: PATH_DASHBOARD.master.party,
          },
        ],
      },
    ],
  },

  //inventory
  {
    subheader: "Inventory",
    items: [
      {
        title: "Inventory",
        path: PATH_DASHBOARD.inventory.root,
        icon: ICONS.master,

        children: [
          { title: "Dashboard", path: PATH_DASHBOARD.inventory.dashboard },
          { title: "Draft Order", path: PATH_DASHBOARD.inventory.draftOrder },
          {
            title: "Purchase Order",
            path: PATH_DASHBOARD.inventory.purchaseOrder,
          },

          { title: "Outward Order", path: PATH_DASHBOARD.inventory.outWard },
          // { title: "Inventory Stock Management", path: PATH_DASHBOARD.inventory.stockManage },
        ],
      },
    ],
  },

  {
    subheader: "User",

    items: [
      // USER
      // {
      //   title: "Parent",
      //   path: PATH_DASHBOARD.general.parentList,
      //   icon: ICONS.parent,
      // },
      {
        title: "Students",
        path: PATH_DASHBOARD.general.studenstList,
        icon: ICONS.user,
      },
    ],
  },

  {
    subheader: "Reports Module",
    items: [
      // USER
      {
        title: "Order Reports",
        path: PATH_DASHBOARD.reports.root,
        icon: ICONS.report,

        children: [
          // {
          //   title: "Student Sizing",
          //   path: PATH_DASHBOARD.reports.studentSizingReport,
          // },
          {
            title: "Order Summary",
            path: PATH_DASHBOARD.reports.orderSummary,
          },
          {
            title: "New Order",
            path: PATH_DASHBOARD.reports.newReport,
          },
          {
            title: "Student Wise Pending Order",
            path: PATH_DASHBOARD.reports.studentwisependingReport,
          },
          {
            title: "School Wise Pending Order",
            path: PATH_DASHBOARD.reports.schoolwisependingReport,
          },
          {
            title: "New & Pending Order",
            path: PATH_DASHBOARD.reports.newAndPending,
          },
          {
            title: "Product Order",
            path: PATH_DASHBOARD.reports.dateWiseReport,
          },
          {
            title: "Order Wise GST",
            path: PATH_DASHBOARD.reports.orderWiseGSTReport,
          },
          {
            title: "With GST",
            path: PATH_DASHBOARD.reports.salesWithGst,
          },
          {
            title: "Without GST",
            path: PATH_DASHBOARD.reports.salesWithOutGst,
          },
          {
            title: "Shipping",
            path: PATH_DASHBOARD.reports.shippingReport,
          },
          {
            title: "Sales",
            path: PATH_DASHBOARD.reports.salesReport,
          },
          {
            title: "Settlement",
            path: PATH_DASHBOARD.reports.settlementReport,
          },
        ],
      },
    ],
  },

  {
    subheader: "Courier Module",
    items: [
      // USER
      {
        title: "Courier",
        path: PATH_DASHBOARD.courier.root,
        icon: ICONS.master,

        children: [
          {
            title: "Delivery Company",
            path: PATH_DASHBOARD.courier.addCompany,
          },
          { title: "Rider", path: PATH_DASHBOARD.courier.addRider },
          // { title: "Add Delivery", path: PATH_DASHBOARD.courier.addDelivery },
          // { title: "Order Status", path: PATH_DASHBOARD.courier.orderStatus },
          // { title: "Rider Status", path: PATH_DASHBOARD.courier.riderStatus },
        ],
      },
    ],
  },
  // {
  //   subheader: "Test Module",
  //   items: [
  //     {
  //       title: "Stability Report",
  //       path: PATH_DASHBOARD.reports.testReport,
  //     },
  //   ],
  // },
  //     // E-COMMERCE
  //     {
  //       title: 'e-commerce',
  //       path: PATH_DASHBOARD.eCommerce.root,
  //       icon: ICONS.cart,
  //       children: [
  //         { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
  //         { title: 'product', path: PATH_DASHBOARD.eCommerce.demoView },
  //         { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
  //         { title: 'create', path: PATH_DASHBOARD.eCommerce.new },
  //         { title: 'edit', path: PATH_DASHBOARD.eCommerce.demoEdit },
  //         { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
  //       ],
  //     },

  //     // INVOICE
  //     {
  //       title: 'invoice',
  //       path: PATH_DASHBOARD.invoice.root,
  //       icon: ICONS.invoice,
  //       children: [
  //         { title: 'list', path: PATH_DASHBOARD.invoice.list },
  //         { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.invoice.new },
  //         { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
  //       ],
  //     },

  //     // BLOG
  //     {
  //       title: 'blog',
  //       path: PATH_DASHBOARD.blog.root,
  //       icon: ICONS.blog,
  //       children: [
  //         { title: 'posts', path: PATH_DASHBOARD.blog.posts },
  //         { title: 'post', path: PATH_DASHBOARD.blog.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.blog.new },
  //       ],
  //     },
  //   ],
  // },

  // APP
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail,
  //       info: (
  //         <Label variant="outlined" color="error">
  //           +32
  //         </Label>
  //       ),
  //     },
  //     { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //     { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
  //     { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban },
  //   ],
  // },
];

export default navConfig;
